import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

// -----------------------------------------------------------------
// COMPONENTS/COMPONENTES
// -----------------------------------------------------------------
import { UserComponent } from './user.component';
import { UserHomeComponent } from './user-home/user-home.component';

//import { MapaIglesiasComponent } from './mapa-church/mapa-church.component';

const routes: Routes = [
    {
        path: '',
        component: UserComponent,

        children: [
            {
                path: '',
                redirectTo: 'mapa-church',
                pathMatch: 'full',
            },
            {
                path: 'home',
                component: UserHomeComponent
            },
            // {
            //     path: 'mapa-church',
            //     component: MapaIglesiasComponent
            // }
        ]
    },
    
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/user/user-routing.module.ts